/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from "react";
import { useAppDispatch } from "../../app/hooks";
import { renewTokenIfNeeded, RENEW_INTERVAL_MS } from "../../helpers/TokenRenewHelper";

// Router'ın dışında, uygulama ömrü boyunca tek sefer mount olan bir sağlayıcı.
// Açılışta ve periyodik olarak token'ı proaktif yeniler, böylece kullanıcı farkında
// olmadan oturum sürer. Navigasyonda remount olmadığı için interval sıfırlanmaz.
export function TokenRenewProvider(props: any) {
    const dispatch = useAppDispatch();

    useEffect(() => {
        // Açılışta bir kez kontrol et.
        renewTokenIfNeeded(dispatch);

        // Uygulama açık kaldıkça periyodik kontrol.
        const intervalId = setInterval(() => renewTokenIfNeeded(dispatch), RENEW_INTERVAL_MS);
        return () => clearInterval(intervalId);
    }, [dispatch]);

    return (
        <React.Fragment>
            {props.children}
        </React.Fragment>
    );
}
